module.exports = __webpack_public_path__ + "img/capital-fr-vector-logo.074aad57.svg";